<script setup>

</script>

<template>
    <div class="Wrapper">
        <slot />
    </div>
</template>


<style lang="scss" scoped>
.Wrapper {
    padding: 50px 80px;
    position: relative;
}
</style>
